import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import './location-card.scss';

const LocationCard = ({ zipcode, city, state, onRemove }) => {
  return (
    <Box className="location-card__location-card-box">
      <Box className="location-card__location-info">
        <Box className="location-card__location-field">
          <Typography className="location-card__location-label">
            Zipcode
          </Typography>
          <Typography className="location-card__location-value">
            {zipcode}
          </Typography>
        </Box>

        <Box className="location-card__location-field">
          <Typography className="location-card__location-label">
            City
          </Typography>
          <Typography className="location-card__location-value">
            {city}
          </Typography>
        </Box>

        <Box className="location-card__location-field">
          <Typography className="location-card__location-label">
            State
          </Typography>
          <Typography className="location-card__location-value">
            {state}
          </Typography>
        </Box>
      </Box>

      <IconButton
        className="location-card__remove-btn"
        onClick={onRemove}
      >
        <Close />
      </IconButton>
    </Box>
  );
};

export default LocationCard;
